<template>
  <app-alert-in-page
    data-locator="notarity-banner"
    :hasLeftBorder="false"
    no-icon
    variant="info"
    class="flex-fill"
  >
    <div class="banner-wrapper">
      <img src="@/assets/img/notarity/notarity-logo.svg" width="120" alt="Notarity Logo"/>
      <p class="mr-auto mb-0">{{ $t('project.signed-documents.SignedDocumentsNotarityBanner.authenticateSignatureText') }}</p>
      <div class="button-group">
      <app-button
        :href="$t('project.signed-documents.SignedDocumentsNotarityBanner.moreInfoLink')"
        class="ml-auto text-darkBlue no-shrink"
        data-locator="more-info-button"
        size="small"
        type="ghost"
        target="_blank"
      >
        {{ $t('project.signed-documents.SignedDocumentsNotarityBanner.moreInfo') }}
      </app-button>
      <app-button
        :href="$t('project.signed-documents.SignedDocumentsNotarityBanner.authenticateSignatureLink')"
        class="no-shrink"
        data-locator="authenticate-signature-button"
        size="small"
        target="_blank"
        type="outlined"
        variant="project"
      >
        {{ $t('project.signed-documents.SignedDocumentsNotarityBanner.authenticateSignatureButton') }}
      </app-button>
      </div>
    </div>
  </app-alert-in-page>
</template>

<script>

export default {
  name: 'SignedDocumentsNotarityBanner',
}
</script>

<style scoped lang="scss">
@import "vuetify/settings";

  .banner-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    column-gap: 16px;

    .button-group {
      display: flex;
      column-gap: 8px;
    }

    @media #{map-get($display-breakpoints, 'md-and-down')} {
      flex-direction: column;
      align-items: flex-start;
      row-gap: 16px;
      
      .button-group {
        flex-direction: row-reverse;
      }
    }
  }
</style>